import {I18n} from '@aws-amplify/core';
import {DrawerProps} from '@mantine/core';
import {PlatformDrawer} from '@flexinet/ui-components';

import {RecordForm} from '../forms/RecordForm';
import {BillableUnit} from '../types';

export const FormDrawer = (
    {
        record,
        handleSubmit,
        opened,
        onClose,
        ...rest
    }: DrawerProps & {
        record: BillableUnit,
        handleSubmit: (values: BillableUnit) => Promise<unknown>
    }) => {

    const title = record?.id ? I18n.get('Edit Billable Unit') : I18n.get('Add Billable Unit');

    // Close only once the server has accepted the save. A refusal is toasted by the
    // mutation's onError, and the drawer stays open with the operator's input intact.
    const handleFormSubmit = async (values: BillableUnit) => {
        try {
            await handleSubmit(values);
        } catch {
            return;
        }
        onClose();
    };

    return (
        <PlatformDrawer
            opened={opened}
            onClose={onClose}
            title={title}
            {...rest}
        >
            <RecordForm
                record={record}
                handleSubmit={handleFormSubmit}
                handleCancel={onClose}
            />
        </PlatformDrawer>
    )
};
